<template>
  <footer
    class="footer"
    style="background-color: lightslategrey; padding: 0px;"
  >
    <div class="md-layout" style="align-items: center;">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <ul>
          <li>
            &nbsp;&nbsp;
          </li>
          <li style="margin-right: -20px">
            <a
              href="https://apps.apple.com/ca/app/rpas-wilco-drone-flight-plans/id1489553409"
              target="_blank"
            >
              <img
                src="img/apple.png"
                alt="APPLE STORE"
                title="APPLE STORE"
                style="height: 36px;"
              />
            </a>
          </li>
          <li style="margin-right: -20px">
            <a
              href="https://play.google.com/store/apps/details?id=com.wilco"
              target="_blank"
            >
              <img
                src="img/google.png"
                alt="PLAY STORE"
                title="PLAY STORE"
                style="height: 36px;"
              />
            </a>
          </li>
          <li style="margin-right: -20px">
            <a href="https://www.facebook.com/rpaswilco" target="_blank">
              <img src="/img/facebook.png" style="width: 24px; height: 24px;" />
            </a>
          </li>
          <li style="margin-right: -20px">
            <a href="https://www.instagram.com/rpaswilco/" target="_blank">
              <img
                src="/img/instagram.png"
                style="width: 24px; height: 24px;"
              />
            </a>
          </li>
          <li style="margin-right: -20px">
            <a
              href="https://www.linkedin.com/company/rpaswilco"
              target="_blank"
            >
              <img src="/img/linkedin.png" style="width: 24px; height: 24px;" />
            </a>
          </li>
        </ul>
      </div>
      <div class="md-layout-item md-size-50 md-small-size-100">
        <ul style="float: right; color:azure;">
          <li>
            <a href="#/tnc" target="_blank">{{ $t("Terms of Use") }}</a>
          </li>
          <li>
            <a href="#/privacy" target="_blank">{{ $t("Privacy") }}</a>
          </li>
          <li>
            <a
              :href="
                this.language === 'fr'
                  ? 'https://laws-lois.justice.gc.ca/fra/reglements/DORS-96-433/TexteComplet.html'
                  : 'https://laws-lois.justice.gc.ca/eng/regulations/SOR-96-433/FullText.html'
              "
              target="_blank"
              >{{ $t("Canadian Aviation Regulations") }}</a
            >
          </li>
          <li>
            <a href="https://aimrobotics.io/" target="_blank"
              >&copy; {{ new Date().getFullYear() }} AIM Robotics</a
            >
          </li>
        </ul>
      </div>
    </div>
    <modal v-if="showLogin">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeLogin"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <login></login>
      </template>
    </modal>

    <modal v-if="showSignup">
      <template slot="header">
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeSignup"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <register></register>
      </template>
    </modal>
  </footer>
</template>
<script>
import { Modal } from "@/components";
import { EventBus } from "@/helpers";
import Login from "@/pages/Landing/Login.vue";
import Register from "@/pages/Landing/Register.vue";
import swal from "sweetalert2";
export default {
  components: {
    Modal,
    Login,
    Register
  },
  props: {
    aimImg: {
      type: String,
      default: "./img/logosm.png"
    },
    fbImg: {
      type: String,
      default: "./img/fb.png"
    },
    twImg: {
      type: String,
      default: "./img/tw.png"
    },
    appleImg: {
      type: String,
      default: "./img/apple.png"
    },
    playImg: {
      type: String,
      default: "./img/play.png"
    },
    inImg: {
      type: String,
      default: "./img/in.png"
    }
  },
  data() {
    return {
      showLogin: false,
      showSignup: false,
      language: "en"
    };
  },
  methods: {
    login() {
      this.showLogin = true;
    },
    closeLogin() {
      this.showLogin = false;
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    signup() {
      this.showSignup = true;
    },
    closeSignup() {
      this.showSignup = false;
    }
  },
  mounted() {
    this.language = window.localStorage.getItem("locale");
    EventBus.$on("signedup", () => {
      this.showSignup = false;
      swal.fire({
        title: this.$t("Thank You"),
        text: this.$t(
          "You successfully signed up. Please check your email to activate your account!"
        ),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("signedup");
  }
};
</script>
<style></style>
